import { useMutation } from '@tanstack/react-query';
import { validationsApi, type ValidateOrganizationRequest, type OrganizationValidationResult } from '@/lib/api';

interface UseValidateOrganizationOptions {
  onSuccess?: (result: OrganizationValidationResult) => void;
  onError?: (error: Error) => void;
}

export function useValidateOrganization(options?: UseValidateOrganizationOptions) {
  return useMutation({
    mutationFn: (data: ValidateOrganizationRequest) =>
      validationsApi.validateOrganization(data),
    onSuccess: (result) => {
      options?.onSuccess?.(result);
    },
    onError: (error) => {
      console.error('Organization validation failed:', error);
      options?.onError?.(error instanceof Error ? error : new Error(String(error)));
    },
  });
}
